import { useWindowSize } from 'react-use';

export default function useIsDesktop() {
	const { width } = useWindowSize();
	return width > 481;
}
